// extracted by mini-css-extract-plugin
export var active = "Carousel-module--active--47b35";
export var arrow = "Carousel-module--arrow--0312c";
export var cMarginTop = "Carousel-module--c-margin-top--3f631";
export var cPadding = "Carousel-module--c-padding--19f0a";
export var cPaddingBottom = "Carousel-module--c-padding-bottom--06850";
export var cPaddingTop = "Carousel-module--c-padding-top--22ced";
export var carousel = "Carousel-module--carousel--59be6";
export var carouselContainer = "Carousel-module--carouselContainer--85009";
export var disabled = "Carousel-module--disabled--21d99";
export var dot = "Carousel-module--dot--3473a";
export var dots = "Carousel-module--dots--c6069";
export var item = "Carousel-module--item--40263";
export var itemsWrapper = "Carousel-module--itemsWrapper--8fa12";
export var left = "Carousel-module--left--dad63";
export var maxWidth = "Carousel-module--max-width--6884e";
export var right = "Carousel-module--right--024b7";